// import Alpine from '../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.store('unreadMessages', {
    data: {},

    init(){
        window.addEventListener('unreadMessages::down', ({detail: mainEventId}) => {
            this.data[mainEventId] -= 1;
        });

        window.addEventListener('unreadMessages::up', ({detail: mainEventId}) => {
            this.data[mainEventId] += 1;
        });
    },

    get(mainEventId){
        if (!mainEventId || ! Object.prototype.hasOwnProperty.call(this.data, mainEventId)) {
            return 0;
        }

        return this.data[mainEventId];
    },

    async syncData(url){
        const csrfToken = document.head
            .querySelector('[name="csrf-token"]')
            ?.getAttribute('content');

        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-TOKEN": csrfToken,
            },
        });

        this.data = await response.json();
    },

    get total(){
        return Object.keys(this.data)
            .reduce((count, mainEventId) => count + this.data[mainEventId], 0);
    },
});
